import { cn } from '@/lib/utils';

function HistoricoSkeletonBar({ width, center }: { width: string; center?: boolean }) {
  return (
    <div
      className={cn('h-3 rounded bg-muted animate-pulse', center && 'mx-auto')}
      style={{ width }}
    />
  );
}

export function HistoricoSkeletonRow() {
  return (
    <tr>
      <td className="px-3 py-3">
        <HistoricoSkeletonBar width="65%" />
      </td>
      <td className="px-3 py-3">
        <HistoricoSkeletonBar width="80%" />
      </td>
      <td className="px-3 py-3">
        <HistoricoSkeletonBar width="55%" />
      </td>
      <td className="px-3 py-3">
        <HistoricoSkeletonBar width="70%" center />
      </td>
      <td className="px-3 py-3">
        <HistoricoSkeletonBar width="40%" center />
      </td>
      <td className="px-3 py-3">
        <HistoricoSkeletonBar width="40%" center />
      </td>
      <td className="px-3 py-3">
        <HistoricoSkeletonBar width="40%" center />
      </td>
      <td className="px-3 py-3">
        <HistoricoSkeletonBar width="35%" center />
      </td>
      <td className="px-3 py-3">
        <HistoricoSkeletonBar width="56px" center />
      </td>
    </tr>
  );
}
